import React from 'react';
import Icon from '../../../components/AppIcon';

const ImpactMetricsCard = ({ metrics }) => {
  const metricIcons = {
    'Total Volunteers': 'Users',
    'Organizations Served': 'Building2',
    'Skills Matched': 'Target',
    'Community Impact': 'Heart'
  };

  const metricColors = {
    'Total Volunteers': 'text-blue-600 bg-blue-50',
    'Organizations Served': 'text-green-600 bg-green-50',
    'Skills Matched': 'text-purple-600 bg-purple-50',
    'Community Impact': 'text-red-600 bg-red-50'
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-md border border-border">
      <h2 className="text-xl font-bold text-foreground mb-4 flex items-center gap-2">
        <Icon name="BarChart3" size={24} className="text-primary" />
        Community Impact Metrics
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {metrics?.map((metric, index) => (
          <div
            key={index}
            className="p-4 rounded-lg border border-border hover:border-primary hover:shadow-md transition-all"
          >
            <div className="flex items-center gap-3 mb-3">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${metricColors?.[metric?.label]}`}>
                <Icon name={metricIcons?.[metric?.label]} size={24} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-muted-foreground">{metric?.label}</p>
                <p className="text-2xl font-bold text-foreground">{metric?.value}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full bg-primary rounded-full transition-all"
                  style={{ width: `${metric?.progress}%` }}
                />
              </div>
              <span className="text-xs font-medium text-primary">{metric?.progress}%</span>
            </div>
            <p className="text-xs text-muted-foreground mt-2">{metric?.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImpactMetricsCard;